// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"38":"3628b906","162":"d83ad269","690":"9d3631af","875":"dcf928f6","896":"d83ad269","940":"dcf928f6","980":"dcf928f6"}[chunkId] + ".css";
};